import { withDevtools } from '@ngrx-toolkit/core';
import { signalStore } from '@ngrx/signals';
import { withIQBoostConversation } from './iqboost-conversation.feature';

// Outlives the dialog, in memory only: a page refresh starts a new chat; the list comes back.
export const IQBoostAllHouseholdsStore = signalStore(
  withDevtools('iqboost-all-households'),
  withIQBoostConversation(),
);

export type IQBoostAllHouseholdsStore = InstanceType<typeof IQBoostAllHouseholdsStore>;
